import React, { Dispatch } from 'react';
import Chip from './Chip';
import { Data, Action } from '../../../ThemeSettingContent';

interface ChipListProps {
  data: Data;
  setState: Dispatch<Action>;
}

const ChipList = ({ data, setState }: ChipListProps) => {
  return (
    <article style={{ display: 'flex' }}>
      {data.static_colors.map((chipValue) => (
        <Chip key={chipValue.id} chipValue={chipValue} setState={setState} data={data} />
      ))}
    </article>
  );
};

export default ChipList;
